import { useParams } from 'react-router-dom'
import { useResidentDetailWorkflow } from './useResidentDetailWorkflow'

export function useResidentDetailPage() {
  const { applicantId, userId } = useParams<{ applicantId: string; userId: string }>()
  return useResidentDetailWorkflow(applicantId, userId)
}

export type ResidentDetailPageContext = ReturnType<typeof useResidentDetailPage>
